import React, { useEffect, useRef, useState } from "react";
import { Dropdown, Menu } from "antd";

import MasterLayout from "../../components/Layout/MasterLayout";
import { Button, Image } from "react-bootstrap";
import logo from "../../assets/images/InicImg.png";
import BasicInfo from "../../components/ProfileData/BasicInfo";
import ProfessionalDetail from "../../components/ProfileData/ProfessionalDetail";
import AddressDetail from "../../components/ProfileData/AddressDetail";
import DocumentUpload from "../../components/DocumentUpload";
import {
  getItem,
  removeItem,
  setItem,
  showSuccessToast,
  validateEmail,
  validateMobile,
  validateName,
} from "../../utils/Functions";
import ErrorMessage from "../../utils/ErrorMessage";
import { useDispatch, useSelector } from "react-redux";
import {
  addCvDetails,
  guestCandidateForm,
  offeredCandidateProfile,
  stopLoading,
} from "./actions";
import ACTION from "../../actions";
import { useHistory, useLocation } from "react-router-dom";
import { paths } from "../../router/Constant";
import DocumentPreview from "../../components/DocumentPreview";
import ProfileImgPreview from "../../components/ProfilePreview";
import DocsUpload from "../../components/DocumentUpload/DocsUpload";

const AddProfile = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const appliedJob = location?.state?.job;
  const [submitSuccess, setSubmitSuccess] = useState(false);
  let type = getItem("type");

  const userInfo = JSON.parse(getItem("User") || "{}");
  let candidateId = userInfo._id;
  const loginEmail =
    userInfo?.emailId ||
    userInfo?.email ||
    getItem("emailId") ||
    "";

  useEffect(() => {
    if (type === "candidate") {
      history.push("/job-opening");
    }
  }, [type]);

  useEffect(() => {
    if (candidateId) {
      dispatch(offeredCandidateProfile(candidateId));
    }
  }, [candidateId]);
  const offeredCandidateReduxData = useSelector(
    (state) => state.profile.OfferedCandidateProfileDetails
  );
  const skillMaster = useSelector((state) => state.profile.masterSkills);
  const qualificationList = useSelector(
    (state) => state.profile.qualificationList
  );
  const skillSetList = useSelector((state) => state.profile.skillSetList);

  const cvInfo = useSelector((state) => state.profile.getCandidateCvDetails);

  const normalizeSkillName = (name) =>
    String(name || "")
      .toLowerCase()
      .replace(/[^a-z0-9]/g, "");

  // Prefer resume `rawSkills`; map to master list IDs when possible
  const buildSkillOptionsFromCv = (rawSkills, candidateSkillSet) => {
    const names = [];
    const pushUnique = (name) => {
      const trimmed = String(name || "").trim();
      if (!trimmed) return;
      if (names.some((n) => n.toLowerCase() === trimmed.toLowerCase())) return;
      names.push(trimmed);
    };

    if (Array.isArray(rawSkills) && rawSkills.length) {
      rawSkills.forEach(pushUnique);
    } else if (Array.isArray(candidateSkillSet)) {
      candidateSkillSet.forEach((s) => pushUnique(s?.skill));
    }

    return names.map((name) => {
      const compact = normalizeSkillName(name);
      const master =
        skillSetList?.find(
          (s) => s.skill?.toLowerCase() === name.toLowerCase()
        ) ||
        skillSetList?.find(
          (s) => normalizeSkillName(s.skill) === compact
        ) ||
        null;

      if (master) {
        return { label: master.skill, value: master._id };
      }

      // Keep full resume skill name (do not use fuzzy truncated master matches)
      return { label: name, value: "" };
    });
  };

  // Match CV degree text (e.g. "B.Tech in Computer Science") to master qualification options
  const findQualificationOption = (degreeText) => {
    if (!degreeText || !qualificationList?.length) return null;
    const normalized = String(degreeText).toLowerCase().trim();
    const compact = normalized.replace(/[.\s_-]/g, "");

    const exact = qualificationList.find(
      (q) => q.qualification?.toLowerCase() === normalized
    );
    if (exact) return { label: exact.qualification, value: exact._id };

    // Prefer longest master name contained in the degree string (ignore dots/spaces)
    const partial = [...qualificationList]
      .filter((q) => {
        const qName = String(q.qualification || "").toLowerCase();
        const qCompact = qName.replace(/[.\s_-]/g, "");
        if (!qCompact || qCompact.length < 2) return false;
        return compact.includes(qCompact) || normalized.includes(qName);
      })
      .sort(
        (a, b) =>
          String(b.qualification).length - String(a.qualification).length
      )[0];
    if (partial) return { label: partial.qualification, value: partial._id };

    return null;
  };

  const [showResumePhotoUpload, setShowResumePhotoUpload] = useState(false);
  const [uploadType, setUploadType] = useState("");
  const [photoFormData, setPhotoFormData] = useState("");
  const [resumeFormData, setResumeFormData] = useState("");
  const [resume, setResume] = useState("");
  const [photo, setPhoto] = useState("");
  const [showResume, setShowResume] = useState(false);
  const [showPhoto, setShowPhoto] = useState(false);

  // Ensure profile page layout stays light mode background (no black sides in dark theme)
  useEffect(() => {
    document.body.classList.add("profile-orange-page-mode");
    document.documentElement.classList.add("profile-orange-page-mode");

    // Topbar isn't rendered here (hideChrome), so dark-theme markers set on a
    // previous page would linger and restyle this page until a reload. Clear
    // them while mounted and restore on leave.
    const prevTheme = document.documentElement.getAttribute("data-theme");
    const hadDarkClass = document.body.classList.contains("dark-theme");
    document.documentElement.removeAttribute("data-theme");
    document.body.classList.remove("dark-theme");

    return () => {
      document.body.classList.remove("profile-orange-page-mode");
      document.documentElement.classList.remove("profile-orange-page-mode");
      if (prevTheme) document.documentElement.setAttribute("data-theme", prevTheme);
      if (hadDarkClass) document.body.classList.add("dark-theme");
    };
  }, []);

  // Refs for scroll-based sticky aside on mobile
  const asideRef = useRef(null);
  const sentinelRef = useRef(null);
  const spacerRef = useRef(null);

  // After aside scrolls out of view → make it fixed+compact; restore when back
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 860px)");
    if (!mq.matches) return; // desktop: no observer needed

    // Reset scroll to top on mount — fixes SPA navigation where previous
    // page scroll position is preserved and sentinel is already off-screen
    window.scrollTo(0, 0);

    const aside = asideRef.current;
    const sentinel = sentinelRef.current;
    const spacer = spacerRef.current;
    if (!aside || !sentinel || !spacer) return;

    // Skip the very first callback: IntersectionObserver fires once on mount
    // to report initial visibility. We want sticky only on actual user scroll.
    let isInitial = true;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (isInitial) {
          isInitial = false;
          return;
        }
        const isOffScreen = !entry.isIntersecting;
        if (isOffScreen) {
          // Capture aside height before going fixed, set spacer to same height
          spacer.style.height = aside.offsetHeight + "px";
          aside.classList.add("profile-aside-is-sticky");
        } else {
          aside.classList.remove("profile-aside-is-sticky");
          spacer.style.height = "0px";
        }
      },
      { threshold: 0, rootMargin: "0px" }
    );

    observer.observe(sentinel);
    return () => observer.disconnect();
  }, []);

  const canSubmit = Boolean(photo && resume);
  let initialBasicInfo = {
    firstName: "",
    lastName: "",
    email: loginEmail,
    secondaryEmail: "",
    mobile: "",
    phone: "",
    gender: "",
    //jobLocation: "",
    noticePeriod: "",
    currentLocation: "",
    phoneCode: "91",   // Default India dial code
    mobileCode: "91",  // Default India dial code
  };
  const [basicinfo, setBasicInfo] = useState(initialBasicInfo);

  // Keep login email in form (profile API / User object)
  useEffect(() => {
    const profileEmail =
      offeredCandidateReduxData?.emailId ||
      offeredCandidateReduxData?.email ||
      offeredCandidateReduxData?.basicInfo?.email ||
      loginEmail;
    if (!profileEmail) return;
    setBasicInfo((prev) =>
      prev.email === profileEmail ? prev : { ...prev, email: profileEmail }
    );
  }, [offeredCandidateReduxData, loginEmail]);

  let initialProfessionalDetails = {
    skillSet: [],
    totalExprience: "",
    relevantExperience: "",
    currentSalary: "",
    // expectedSalary: "",
    currentDesignation: "",
    currentEmployer: "",
    expectedjoiningDate: new Date(),
    highestQualification: "",
    additionalInfo: "",
    portfolio: "",
    skypeId: "",
  };

  const [professionaldetails, setprofessionalDetails] = useState(
    initialProfessionalDetails
  );
  const [educationdetails, setEducationDetails] = useState([]);
  const [experiencedetails, setExperienceDetails] = useState([]);
  let initialAddressDetails = {
    street: "",
    postalCode: "",
    city: "",
    state: "",
    country: "",
  };
  const [addressdetails, setaddressDetails] = useState(initialAddressDetails);
  let initialBasicErrors = {
    firstName: "",
    lastName: "",
    email: "",
    secondaryEmail: "",
    mobile: "",
    phone: "",
  };
  const [basicErrors, setBasicErrors] = useState(initialBasicErrors);
  let initialProfessionalErrors = {
    highestQualification: "",
    skillSet: "",
    totalExperience: "",
    currentSalary: "",
    // currentDesignation: "",
    currentEmployer: "",
  };
  const [professionalErrors, setProfessionalErrors] = useState(
    initialProfessionalErrors
  );
  let initialEducationErrors = {
    education: "",
  };
  const [educationErrors, setEducationErrors] = useState(
    initialEducationErrors
  );
  let initialAddressErrors = {
    city: "",
    country: "",
  };
  const [addressErrors, setAddressErrors] = useState(initialAddressErrors);

  const fetchCVInfo = async () => {
    if (resumeFormData !== "") {
      // Clear stale CV first so the apply-effect doesn't stopLoading with old data
      // while the new fetchInfo is still pending (e.g. resume + profile replace)
      dispatch({ type: ACTION.GET_CANDIDATE_CV_DETAILS, CvInfo: null });
      await dispatch(addCvDetails(resumeFormData));
    }
  };

  useEffect(() => {
    fetchCVInfo();
  }, [resumeFormData]);

  // Fresh visit: clear previous resume/CV form state. Leaving page also resets.
  useEffect(() => {
    dispatch({ type: ACTION.GET_CANDIDATE_CV_DETAILS, CvInfo: null });
    removeItem("resume");
    removeItem("photo");
    setResume("");
    setPhoto("");
    setResumeFormData("");
    setPhotoFormData("");

    return () => {
      dispatch({ type: ACTION.GET_CANDIDATE_CV_DETAILS, CvInfo: null });
      removeItem("resume");
      removeItem("photo");
    };
  }, []);

  useEffect(() => {
    // Only apply CV data while a resume is still selected
    if (cvInfo?.data && resumeFormData) {
      let {
        firstName,
        lastName,
        phone,
        candidateSkillSet,
        rawSkills,
        highestQualification,
        currentSalary,
        currentEmployer,
        currentDesignation,
        currentLocation,
        educations,
        experiences,
        // backend returns misspelled key `totalExperiance`
        totalExperiance,
        totalExperience,
        totalExperienceYears,
      } = cvInfo.data;

      // Resume skills first (rawSkills), not fuzzy candidateSkillSet fragments
      const skillArray = buildSkillOptionsFromCv(rawSkills, candidateSkillSet);



      // Normalize total experience (API key is totalExperiance)
      const parsedTotalExperience =
        totalExperiance ?? totalExperience ?? totalExperienceYears ?? null;

      // Highest qualification: prefer API field, else first education degree
      const degreeFromEducation =
        Array.isArray(educations) && educations.length
          ? educations[0]?.degree
          : null;
      const qualificationText =
        (typeof highestQualification === "object"
          ? highestQualification?.label || highestQualification?.value
          : highestQualification) || degreeFromEducation || "";
      const matchedQualification = findQualificationOption(qualificationText);

      // Parse "Ahmedabad, India" → city + country for Address Details
      let parsedCity = "";
      let parsedCountry = "";
      if (currentLocation) {
        const parts = String(currentLocation)
          .split(",")
          .map((p) => p.trim())
          .filter(Boolean);
        if (parts.length >= 2) {
          parsedCity = parts[0];
          parsedCountry = parts[parts.length - 1];
        } else if (parts.length === 1) {
          parsedCity = parts[0];
        }
      }

      // Parse phone: strip country code if present (e.g. "918320588636" → phoneCode="91", mobile="8320588636")
      let parsedMobile = "";
      let parsedPhoneCode = "91"; // default India
      if (phone) {
        const phoneStr = String(phone).replace(/\D/g, ""); // keep digits only
        // Common country codes (add more as needed)
        const countryCodes = ["91", "1", "44", "61", "971", "65", "60"];
        let matched = false;
        for (const code of countryCodes) {
          if (phoneStr.startsWith(code) && phoneStr.length > code.length + 5) {
            parsedPhoneCode = code;
            parsedMobile = phoneStr.slice(code.length);
            matched = true;
            break;
          }
        }
        if (!matched) {
          parsedMobile = phoneStr; // no country code prefix detected
        }
      }

      // Always overwrite from latest CV parse (add / re-add resume)
      // Keep login email — CV email must not replace account identity (breaks getCandidateAuthToken)
      setBasicInfo((prevState) => ({
        ...prevState,
        firstName: firstName || "",
        lastName: lastName || "",
        mobile: parsedMobile,
        phoneCode: parsedPhoneCode,
        mobileCode: parsedPhoneCode,
        currentLocation: currentLocation || "",
      }));


      setprofessionalDetails((prevState) => ({
        ...prevState,
        // Match master list (_id) so dropdown + submit both work
        highestQualification: matchedQualification || "",
        currentSalary: currentSalary || "",
        currentEmployer: currentEmployer || "",
        currentDesignation: currentDesignation || "",
        skillSet: skillArray,
        // Form field uses `totalExprience`; map from backend `totalExperiance`
        totalExprience:
          parsedTotalExperience != null ? String(parsedTotalExperience) : "",
      }));

      if (matchedQualification) {
        setProfessionalErrors((prev) => ({
          ...prev,
          highestQualification: "",
        }));
      }

      if (parsedCity || parsedCountry) {
        setaddressDetails((prevState) => ({
          ...prevState,
          city: parsedCity || prevState.city,
          country: parsedCountry
            ? { label: parsedCountry, value: parsedCountry }
            : prevState.country,
        }));
        setAddressErrors((prev) => ({
          ...prev,
          ...(parsedCity ? { city: "" } : {}),
          ...(parsedCountry ? { country: "" } : {}),
        }));
      }

      // Map CV educations / experiences so they are saved on submit
      const mappedEducations = (educations || [])
        .map((edu) => ({
          institute: edu.institute || "",
          major: edu.major || "",
          from: edu.from != null ? String(edu.from) : "",
          to: edu.to != null ? String(edu.to) : "",
        }))
        .filter((edu) => edu.institute || edu.major || edu.from || edu.to);

      const mappedExperiences = (experiences || [])
        .map((exp) => ({
          occupation: exp.occupation || "",
          company: exp.company || "",
          summary: exp.summary || "",
          from: exp.from || "",
          to: exp.to || (exp.isWorking ? "Present" : ""),
        }))
        .filter(
          (exp) =>
            exp.occupation || exp.company || exp.summary || exp.from || exp.to
        );

      if (mappedEducations.length) {
        setEducationDetails(mappedEducations);
      }
      if (mappedExperiences.length) {
        setExperienceDetails(mappedExperiences);
      }
      // Stop the skeleton loader NOW — data has been mapped into form
      dispatch(stopLoading());
    }
    // Only react to new cvInfo (not resumeFormData). Depending on resumeFormData
    // re-applied stale CV data and cleared the skeleton during a replace parse.
  }, [cvInfo, qualificationList]);

  // Called when user removes/clears the resume PDF
  const handleResumeClear = () => {
    dispatch({ type: ACTION.GET_CANDIDATE_CV_DETAILS, CvInfo: null });
    setResumeFormData("");
    setResume("");
    removeItem("resume");
    setBasicInfo((prev) => ({
      ...initialBasicInfo,
      email: prev.email,
    }));
    setprofessionalDetails(initialProfessionalDetails);
    setaddressDetails(initialAddressDetails);
    setEducationDetails([]);
    setExperienceDetails([]);
    setBasicErrors(initialBasicErrors);
    setProfessionalErrors(initialProfessionalErrors);
    setAddressErrors(initialAddressErrors);
  };

  /******************* 
  @Purpose : Used for validate form data
  @Parameter : {}
  @Author : INIC
  ******************/
  const validateForm = () => {
    let tempErrors = {
      firstName: "",
      lastName: "",
      email: "",
      mobile: "",
      gender: "",
      //  jobLocation: "",
      noticePeriod: "",
      highestQualification: "",
      skillSet: "",
      totalExperiance: "",
      relevantExperience: "",
      currentSalary: "",
      //  expectedSalary: "",
      // currentDesignation: "",
      currentEmployer: "",
      secondaryEmail: "",
      education: "",
      city: "",
      country: "",
    };
    let isFormValid = true;

    if (basicinfo.firstName === "") {
      tempErrors.firstName = ErrorMessage.PROVIDE_FIRST_NAME;
      isFormValid = false;
    } else if (!validateName(basicinfo.firstName)) {
      tempErrors.firstName = ErrorMessage.PROVIDE_VALID_FIRST_NAME;
      isFormValid = false;
    } else {
      tempErrors.firstName = "";
    }

    if (basicinfo.lastName === "") {
      tempErrors.lastName = ErrorMessage.PROVIDE_LAST_NAME;
      isFormValid = false;
    } else if (!validateName(basicinfo.lastName)) {
      tempErrors.lastName = ErrorMessage.PROVIDE_VALID_LAST_NAME;
      isFormValid = false;
    } else {
      tempErrors.lastName = "";
    }

    if (basicinfo.email === "") {
      tempErrors.email = ErrorMessage.PROVIDE_EMAIL;
      isFormValid = false;
    } else if (!validateEmail(basicinfo.email)) {
      tempErrors.email = ErrorMessage.PROVIDE_VALID_EMAIL;
      isFormValid = false;
    } else {
      tempErrors.email = "";
    }

    // if (
    //   basicinfo.secondaryEmail !== "" &&
    //   !validateEmail(basicinfo.secondaryEmail)
    // ) {
    //   tempErrors.secondaryEmail = ErrorMessage.PROVIDE_VALID_SECONDARY_EMAIL;
    //   isFormValid = false;
    // } else {
    //   tempErrors.secondaryEmail = "";
    // }

    if (basicinfo.mobile === "") {
      tempErrors.mobile = ErrorMessage.PROVIDE_MOBILE;
      isFormValid = false;
    } else if (!validateMobile(basicinfo.mobile)) {
      tempErrors.mobile = ErrorMessage.PROVIDE_VALID_MOBILE;
      isFormValid = false;
    } else {
      tempErrors.mobile = "";
    }

    // if (basicinfo.phone !== "" && !validatePhone(basicinfo.phone)) {
    //   tempErrors.phone = ErrorMessage.PROVIDE_VALID_PHONE;
    //   isFormValid = false;
    // } else {
    //   tempErrors.phone = "";
    // }

    // if (basicinfo.gender === "") {
    //   tempErrors.gender = ErrorMessage.PROVIDE_GENDER;
    //   isFormValid = false;
    // } else {
    //   tempErrors.gender = "";
    // }

    // if (basicinfo.jobLocation.value === "") {
    //   tempErrors.jobLocation = ErrorMessage.PROVIDE_WORK_PREFRENCE;
    //   isFormValid = false;
    // } else {
    //   tempErrors.jobLocation = "";
    // }

    if (!basicinfo.noticePeriod) {
      tempErrors.noticePeriod = ErrorMessage.PROVIDE_NOTICE_PERIOD;
      isFormValid = false;
    } else {
      tempErrors.noticePeriod = "";
    }

    if (!professionaldetails.highestQualification?.value) {
      tempErrors.highestQualification = ErrorMessage.PROVIDE_QUALIFICATION;
      isFormValid = false;
    } else {
      tempErrors.highestQualification = "";
    }

    if (professionaldetails.skillSet.length === 0) {
      tempErrors.skillSet = ErrorMessage.PROVIDE_SKILL_SET;
      isFormValid = false;
    } else {
      tempErrors.skillSet = "";
    }

    if (!professionaldetails.totalExprience) {
      tempErrors.totalExperiance = ErrorMessage.PROVIDE_TOTAL_EXPERIENCE;
      isFormValid = false;
    } else {
      tempErrors.totalExperiance = "";
    }

    // if (professionaldetails.relevantExperience === "") {
    //   tempErrors.relevantExperience = ErrorMessage.PROVIDE_RELEVENT_EXPERIENCE;
    //   isFormValid = false;
    // } else {
    //   tempErrors.relevantExperience = "";
    // }

    if (!professionaldetails.currentSalary) {
      tempErrors.currentSalary = ErrorMessage.PROVIDE_CURRENT_SALARY;
      isFormValid = false;
    } else {
      tempErrors.currentSalary = "";
    }

    // if (professionaldetails.expectedSalary === "") {
    //   tempErrors.expectedSalary = ErrorMessage.PROVIDE_EXPECTED_SALARY;
    //   isFormValid = false;
    // } else {
    //   tempErrors.expectedSalary = "";
    // }

    // if (professionaldetails.currentDesignation === "") {
    //   tempErrors.currentDesignation = ErrorMessage.PROVIDE_CURRENT_DESIGNATION;
    //   isFormValid = false;
    // } else {
    //   tempErrors.currentDesignation = "";
    // }

    if (!professionaldetails.currentEmployer) {
      tempErrors.currentEmployer = ErrorMessage.PROVIDE_CURRENT_EMPLOYER;
      isFormValid = false;
    } else {
      tempErrors.currentEmployer = "";
    }

    // if (educationdetails.length === 1) {
    //   const firstEducation = educationdetails[0];
    //   const hasEmptyValue = Object.values(firstEducation).some(
    //     (val) => val === null || val === ""
    //   );
    //   if (hasEmptyValue) {
    //     showErrorToast(ErrorMessage.PROVIDE_ONE_EDUCATION);
    //     tempErrors.education = ErrorMessage.PROVIDE_ONE_EDUCATION;
    //     isFormValid = false;
    //   }
    // } else {
    //   tempErrors.education = "";
    // }

    if (!addressdetails.city || addressdetails.city.trim() === "") {
      tempErrors.city = ErrorMessage.PROVIDE_CITY;
      isFormValid = false;
    } else if (!validateName(addressdetails.city)) {
      tempErrors.city = ErrorMessage.PROVIDE_VALID_CITY;
      isFormValid = false;
    } else {
      tempErrors.city = "";
    }

    const countryVal = typeof addressdetails.country === "object" ? addressdetails.country?.value : addressdetails.country;
    if (!countryVal || countryVal.trim() === "") {
      tempErrors.country = ErrorMessage.PROVIDE_COUNTRY;
      isFormValid = false;
    } else {
      tempErrors.country = "";
    }

    setBasicErrors({
      firstName: tempErrors.firstName,
      lastName: tempErrors.lastName,
      email: tempErrors.email,
      secondaryEmail: tempErrors.secondaryEmail,
      mobile: tempErrors.mobile,
      phone: tempErrors.phone,
      noticePeriod: tempErrors.noticePeriod,
    });
    setProfessionalErrors({
      highestQualification: tempErrors.highestQualification,
      skillSet: tempErrors.skillSet,
      totalExperience: tempErrors.totalExperiance,
      currentSalary: tempErrors.currentSalary,
      currentEmployer: tempErrors.currentEmployer,
    });
    setAddressErrors({ city: tempErrors.city, country: tempErrors.country });

    if (!isFormValid) {
      // Scroll to the first invalid field instead of showing a toast
      const fieldOrder = [
        { key: "firstName", id: "field-firstName" },
        { key: "lastName", id: "field-lastName" },
        { key: "mobile", id: "field-mobile" },
        { key: "noticePeriod", id: "field-noticePeriod" },
        { key: "highestQualification", id: "field-highestQualification" },
        { key: "skillSet", id: "field-skillSet" },
        { key: "totalExperiance", id: "field-totalExperiance" },
        { key: "currentSalary", id: "field-currentSalary" },
        { key: "currentEmployer", id: "field-currentEmployer" },
        { key: "city", id: "field-city" },
        { key: "country", id: "field-country" },
      ];
      const firstErrorField = fieldOrder.find((f) => tempErrors[f.key]);
      if (firstErrorField) {
        const el = document.getElementById(firstErrorField.id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }
    }

    return isFormValid;
  };

  /******************* 
   @Purpose : handleSubmit method
  @Parameter : {}
  @Author : INIC
  ******************/
  const handleSubmit = async () => {
    if (validateForm()) {
      // Resolve skill IDs from master list (CV raw skills may have empty value until master sync)
      let skillSet =
        professionaldetails.skillSet.length > 0
          ? professionaldetails.skillSet
            .map((skill) => {
              if (skill?.value) return skill.value;
              const master = skillSetList?.find(
                (s) =>
                  s.skill?.toLowerCase() === skill?.label?.toLowerCase() ||
                  normalizeSkillName(s.skill) ===
                  normalizeSkillName(skill?.label)
              );
              return master?._id || null;
            })
            .filter(Boolean)
          : [];

      let basicInfo = {
        ...basicinfo,
        emailId: basicinfo.email,
        //  jobLocation: basicinfo.jobLocation.value,
      };

      let professionalDetails = {
        ...professionaldetails,
        skillSet,
        qualification: professionaldetails.highestQualification.value,
        totalExperiance: professionaldetails.totalExprience,
        //    relevantExperiance: professionaldetails.relevantExperience,
      };
      let addressDetails = {
        ...addressdetails,
        country: addressdetails.country?.value
          ? addressdetails.country?.value
          : "",
      };
      delete basicInfo.email;
      delete professionalDetails.highestQualification;
      delete professionalDetails.totalExprience;
      delete professionalDetails.relevantExperience;

      // If state arrays are empty (e.g. race condition), fallback to cvInfo.data directly
      const cvEducations = cvInfo?.data?.educations || [];
      const cvExperiences = cvInfo?.data?.experiences || [];

      const validEducations = (
        educationdetails.length > 0 ? educationdetails : cvEducations
      )
        .map((edu) => ({
          institute: edu.institute || "",
          major: edu.major || "",
          from: edu.from != null ? String(edu.from) : "",
          to: edu.to != null ? String(edu.to) : "",
        }))
        .filter((edu) => edu.institute || edu.major || edu.from || edu.to);

      const validExperiences = (
        experiencedetails.length > 0 ? experiencedetails : cvExperiences
      )
        .map((exp) => ({
          occupation: exp.occupation || "",
          company: exp.company || "",
          summary: exp.summary || "",
          from: exp.from || "",
          to: exp.to || (exp.isWorking ? "Present" : ""),
        }))
        .filter(
          (exp) =>
            exp.occupation || exp.company || exp.summary || exp.from || exp.to
        );

      console.log("[AddProfile] Submit educations:", validEducations);
      console.log("[AddProfile] Submit experiences:", validExperiences);

      await dispatch(
        guestCandidateForm(
          {
            id: candidateId,
            ...basicInfo,
            ...professionalDetails,
            ...addressDetails,
            ...(validEducations.length
              ? { educations: validEducations }
              : {}),
            ...(validExperiences.length
              ? { experiences: validExperiences }
              : {}),
            phoneCode: basicinfo?.phoneCode || "91",
            mobileCode: basicinfo?.mobileCode || "91",
            isCompleted: true,
            isDeleted: false,
            isActive: true,
            modifiedBy: candidateId,
          },
          photoFormData,
          photo,
          resumeFormData,
          resume,
          () => setSubmitSuccess(true)
        )
      );
      setItem("qualification", professionaldetails.highestQualification.value);
    }
  };

  const handleResetData = () => {
    dispatch({ type: ACTION.GET_CANDIDATE_CV_DETAILS, CvInfo: null });
    setBasicInfo((prev) => ({
      ...initialBasicInfo,
      email: prev.email,
    }));
    setprofessionalDetails(initialProfessionalDetails);
    setEducationDetails([{ from: "", institute: "", major: "", to: "" }]);
    setExperienceDetails([
      {
        occupation: "",
        company: "",
        summary: "",
        from: "",
        to: "",
      },
    ]);
    setaddressDetails(initialAddressDetails);
    setBasicErrors(initialBasicErrors);
    setProfessionalErrors(initialProfessionalErrors);
    setEducationErrors(initialEducationErrors);
    setAddressErrors(initialAddressErrors);
    // User CV/Photo Data will be reset
    setPhoto("");
    setResume("");
    setPhotoFormData("");
    setResumeFormData("");
    removeItem("photo");
    removeItem("resume");
  };

  /******************* 
  @purpose : Rander HTML/ React Components 
  ******************/
  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const logoutHandler = () => {
    history.push("/");
    localStorage.clear();
    showSuccessToast("Logout Successfully");
  };

  const userMenu = (
    <Menu
      className="profile-orange-user-menu"
      items={[
        {
          key: "logout",
          label: (
            <a
              onClick={logoutHandler}
              className="d-flex align-items-center text-danger fw-medium text-decoration-none"
            >
              <i className="bx bx-log-out me-2 fs-5"></i> Logout
            </a>
          ),
        },
      ]}
    />
  );

  const isBasicInfoFilled =
    basicinfo.firstName?.trim() &&
    validateName(basicinfo.firstName) &&
    basicinfo.lastName?.trim() &&
    validateName(basicinfo.lastName) &&
    basicinfo.email?.trim() &&
    validateEmail(basicinfo.email) &&
    basicinfo.mobile?.trim() &&
    validateMobile(basicinfo.mobile) &&
    basicinfo.noticePeriod;

  const isProfessionalFilled =
    professionaldetails.highestQualification?.value &&
    professionaldetails.skillSet?.length > 0 &&
    professionaldetails.totalExprience &&
    professionaldetails.currentSalary &&
    professionaldetails.currentEmployer;

  const isAddressFilled =
    addressdetails.city?.trim() &&
    validateName(addressdetails.city) &&
    addressdetails.country &&
    (typeof addressdetails.country === "object"
      ? addressdetails.country.value
      : addressdetails.country);

  if (submitSuccess) {
    return (
      <MasterLayout minimalHeader>
        <div className="main-img-bg">
          <div className="profile-success-screen">
            <p className="profile-success-eyebrow">Application received</p>
            <div className="profile-success-icon">
              <i className="bx bx-check" />
            </div>
            <h1 className="profile-success-title">You&apos;re all set.</h1>
            <p className="profile-success-subtitle">
              Your profile has been submitted. Our team will review it and reach
              out if there&apos;s a match — usually within a few business days.
            </p>
            {appliedJob?.title && (
              <div className="profile-success-pill">
                <i className="bx bx-briefcase" />
                Applied for: {appliedJob.title}
              </div>
            )}
            <div className="profile-success-actions">
              <Button
                variant="primary"
                onClick={() => history.push(paths.jobOpenings)}
              >
                View more openings <i className="bx bx-right-arrow-alt" />
              </Button>
              <Button
                variant="secondary"
                onClick={() => history.push(paths.homeLanding)}
              >
                Back to home
              </Button>
            </div>
          </div>
        </div>
      </MasterLayout>
    );
  }

  return (
    <MasterLayout hideChrome>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&display=swap');
        .profile-fraunces-title {
          font-family: 'Fraunces', serif !important;
          font-style: italic !important;
          font-weight: 600 !important;
          color: #fffaf3 !important;
          letter-spacing: -0.03em;
          line-height: 1.1;
        }
        .profile-fraunces-subtitle {
          font-family: 'Poppins', sans-serif !important;
          font-style: normal !important;
          font-weight: 600 !important;
          color: rgba(255, 250, 243, 0.82) !important;
          letter-spacing: -0.01em;
          line-height: 1.5;
        }
        .profile-fraunces-dark {
          font-family: 'Fraunces', serif !important;
          font-style: italic !important;
          font-weight: 600 !important;
          color: #1e2433 !important;
          letter-spacing: -0.03em;
          line-height: 1.1;
        }
      `}</style>
      <div className="profile-orange-shell">
        <aside className="profile-orange-aside" ref={asideRef}>
          <div className="profile-orange-brand">
            <Image
              src={logo}
              variant="top"
              className="header-img"
              alt="IndiaNIC Logo"
            />
          </div>
          <h1 className="profile-fraunces-title">Your next opportunity awaits</h1>
          <p className="profile-fraunces-subtitle">
            Fill in your details and let us know why you&apos;re a great fit for
            the team.
          </p>
          {/* <button
            type="button"
            className="profile-orange-openings-link"
            onClick={() => history.push(paths.jobOpenings)}
          >
            <i className="bx bx-briefcase" aria-hidden="true" />
            <span>View openings</span>
          </button> */}

          <div className="profile-orange-checklist">
            <button
              type="button"
              className="profile-orange-check-item"
              onClick={() => scrollToSection("section-upload")}
            >
              <span className={`check-dot ${resume ? "done" : ""}`}>
                {resume ? "✓" : "1"}
              </span>
              <span>Upload documents</span>
            </button>
            <button
              type="button"
              className="profile-orange-check-item"
              onClick={() => scrollToSection("section-basic-info")}
            >
              <span className={`check-dot ${isBasicInfoFilled ? "done" : ""}`}>
                {isBasicInfoFilled ? "✓" : "2"}
              </span>
              <span>Basic info</span>
            </button>
            <button
              type="button"
              className="profile-orange-check-item"
              onClick={() => scrollToSection("section-professional")}
            >
              <span className={`check-dot ${isProfessionalFilled ? "done" : ""}`}>
                {isProfessionalFilled ? "✓" : "3"}
              </span>
              <span>Professional details</span>
            </button>
            <button
              type="button"
              className="profile-orange-check-item"
              onClick={() => scrollToSection("section-address")}
            >
              <span className={`check-dot ${isAddressFilled ? "done" : ""}`}>
                {isAddressFilled ? "✓" : "4"}
              </span>
              <span>Address details</span>
            </button>
          </div>

          <div className="profile-orange-aside-foot">
            <strong>Need help?</strong>
            <a href="tel:+917961916000" className="profile-orange-contact-link">
              <i className="bx bx-phone" aria-hidden="true" />
              <span>+91 79 6191 6000</span>
            </a>
            <a
              href="mailto:hr@indianic.com"
              className="profile-orange-contact-link"
            >
              <i className="bx bx-envelope" aria-hidden="true" />
              <span>hr@indianic.com</span>
            </a>
          </div>
        </aside>
        {/* Sentinel: sits right after the aside; when it leaves viewport the aside goes sticky */}
        <div ref={sentinelRef} className="profile-aside-sentinel" style={{ height: 0 }} aria-hidden="true" />
        {/* Spacer: prevents layout jump when aside becomes position:fixed */}
        <div ref={spacerRef} className="profile-aside-spacer" style={{ height: 0 }} aria-hidden="true" />

        <main className="profile-orange-main profile-page" id="offer-approval">
          <div className="profile-orange-top-row">
            <div className="profile-orange-title-col">
              <button
                type="button"
                className="profile-orange-back-arrow"
                onClick={() => history.push("/")}
                title="Back"
              >
                <i className="bx bx-arrow-back" />
              </button>
              <h2 className="profile-fraunces-dark">Add your profile details....</h2>
            </div>
            <Dropdown
              overlay={userMenu}
              placement="bottomCenter"
              trigger={["click"]}
              arrow={{ pointAtCenter: true }}
              align={{ offset: [0, -8] }}
            >
              <button
                type="button"
                className={`profile-orange-user-avatar ${(photo || offeredCandidateReduxData?.photo) ? "has-photo" : ""}`}
                title="Account"
              >
                {(photo || offeredCandidateReduxData?.photo) ? (
                  <img
                    src={
                      photo
                        ? (photo.startsWith("http") ? photo : (offeredCandidateReduxData?.FILE_PATH || "") + photo)
                        : (offeredCandidateReduxData?.FILE_PATH || "") + offeredCandidateReduxData.photo
                    }
                    alt="Profile"
                    style={{ width: "100%", height: "100%", borderRadius: "50%", objectFit: "cover" }}
                    onError={(e) => { e.target.style.display = "none"; e.target.nextSibling.style.display = "flex"; }}
                  />
                ) : null}
                <i className="bx bx-user" style={(photo || offeredCandidateReduxData?.photo) ? { display: "none" } : {}} />
              </button>
            </Dropdown>
          </div>

          <div className="consultant-add-form-body">
            <div className="panel profile-orange-panel">
              <div className="panel-header sec-head" id="section-upload">
                <div className="sec-num">
                  <i className="bx bx-upload" />
                </div>
                <div className="title">Upload Documents</div>
              </div>
              <div className="panel-content profile-orange-upload-content">
                <div className="profile-orange-upload-row">
                  <div className="profile-orange-dropzone">
                    <DocsUpload
                      setModalShow={setShowResumePhotoUpload}
                      modalShow={showResumePhotoUpload}
                      isGuest={true}
                      type={"resume"}
                      photo={photo}
                      setPhoto={setPhoto}
                      resume={resume}
                      setResume={setResume}
                      resumeDetails={offeredCandidateReduxData}
                      setPhotoFormData={setPhotoFormData}
                      setResumeFormData={setResumeFormData}
                      onResumeClear={handleResumeClear}
                    />
                  </div>
                  <div className="profile-orange-pfp">
                    <DocsUpload
                      setModalShow={setShowResumePhotoUpload}
                      modalShow={showResumePhotoUpload}
                      isGuest={true}
                      type={"profile"}
                      photo={photo}
                      setPhoto={setPhoto}
                      resume={resume}
                      setResume={setResume}
                      resumeDetails={offeredCandidateReduxData}
                      setPhotoFormData={setPhotoFormData}
                      setResumeFormData={setResumeFormData}
                    />
                  </div>
                </div>
              </div>

              <BasicInfo
                isGuest={true}
                basicinfo={basicinfo}
                setBasicInfo={setBasicInfo}
                errors={basicErrors}
                setErrors={setBasicErrors}
                basicInfo={offeredCandidateReduxData}
              />
              <ProfessionalDetail
                isGuest={true}
                professionaldetails={professionaldetails}
                setprofessionalDetails={setprofessionalDetails}
                errors={professionalErrors}
                setErrors={setProfessionalErrors}
              />
              <AddressDetail
                isGuest={true}
                addressdetails={addressdetails}
                setaddressDetails={setaddressDetails}
                errors={addressErrors}
                setErrors={setAddressErrors}
              />
            </div>

            <div className="profile-orange-actions">
              <div className="req-note">
                {/* Fields marked <span className="req-star">*</span> are required */}
              </div>
              <div className="btn-row">
                <Button
                  variant="outline-secondary"
                  className="profile-orange-btn-ghost"
                  onClick={handleResetData}
                >
                  Clear
                </Button>
                <Button
                  className="profile-orange-btn-primary"
                  onClick={() => handleSubmit()}
                >
                  Submit →
                </Button>
              </div>
            </div>
          </div>
        </main>

        <ProfileImgPreview
          setModalShow={setShowPhoto}
          photoUrl={photo}
          modalShow={showPhoto}
          setShowResumeUpload={setShowResumePhotoUpload}
          setPhoto={setPhoto}
        />
        <DocumentPreview
          setModalShow={setShowResume}
          docs={[{ uri: resume }]}
          modalShow={showResume}
          isGuest={true}
          setShowResumeUpload={setShowResumePhotoUpload}
          setResume={setResume}
        />
        <DocumentUpload
          setModalShow={setShowResumePhotoUpload}
          modalShow={showResumePhotoUpload}
          isGuest={true}
          type={uploadType}
          photo={photo}
          setPhoto={setPhoto}
          resume={resume}
          setResume={setResume}
          resumeDetails={offeredCandidateReduxData}
          setPhotoFormData={setPhotoFormData}
          setResumeFormData={setResumeFormData}
        />
      </div>
    </MasterLayout>
  );
};

export default AddProfile;
